import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonNotebookModel extends ModeModelBase {
  override _name = 'pythonNotebook';
  override belongsTo = 'report';
  override parentIdAttribute = 'token';
  override hasMany = [
    { name: 'pythonSessions' },
    { name: 'pythonSessions', as: 'perspectivePythonSessions' },
    { name: 'pythonCells' },
    { name: 'pythonCellBatchRuns' },
  ];
  override attributes = [{ name: 'pusherChannelName', default: '' }];
}

@Injectable({ providedIn: 'root' })
export class PythonNotebookModelAccessor extends ModelAccessorBase<PythonNotebookModel> {
  override name = 'pythonNotebook';
  override parentModel = 'report';
  override parentIdAttribute = 'token';
  override getIdFromLink = (link) => {
    return link.split('?')[0];
  };
  createModel(resource, opts?) {
    const model = new PythonNotebookModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonNotebook');
  }
}
